import { render, staticRenderFns } from "./UpdatePushNotification.vue?vue&type=template&id=5b6c320b&"
import script from "./UpdatePushNotification.vue?vue&type=script&lang=js&"
export * from "./UpdatePushNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports